const resistanceTable = {
  "crystal": {
    "crystal": 1,
    "digital": 1,
    "earth": 2,
    "electric": 0.5,
    "fire": 2,
    "melee": 2,
    "mental": 0.5,
    "nature": 1,
    "neutral": 1,
    "toxic": 0.5,
    "water": 1,
    "wind": 1,
  },
  "digital": {
    "crystal": 1,
    "digital": 2,
    "earth": 1,
    "electric": 2,
    "fire": 1,
    "melee": 1,
    "mental": 1,
    "nature": 1,
    "neutral": 1,
    "toxic": 0.5,
    "water": 2,
    "wind": 1,
  },
  "earth": {
    "crystal": 0.5,
    "digital": 1,
    "earth": 1,
    "electric": 0.5,
    "fire": 0.5,
    "melee": 2,
    "mental": 1,
    "nature": 2,
    "neutral": 1,
    "toxic": 0.5,
    "water": 2,
    "wind": 1,
  },
  "electric": {
    "crystal": 2,
    "digital": 1,
    "earth": 2,
    "electric": 0.5,
    "fire": 1,
    "melee": 1,
    "mental": 1,
    "nature": 1,
    "neutral": 1,
    "toxic": 1,
    "water": 1,
    "wind": 0.5,
  },
  "fire": {
    "crystal": 0.5,
    "digital": 1,
    "earth": 2,
    "electric": 1,
    "fire": 0.5,
    "melee": 1,
    "mental": 1,
    "nature": 0.5,
    "neutral": 1,
    "toxic": 1,
    "water": 2,
    "wind": 1,
  },
  "melee": {
    "crystal": 1,
    "digital": 2,
    "earth": 1,
    "electric": 1,
    "fire": 1,
    "melee": 0.5,
    "mental": 2,
    "nature": 1,
    "neutral": 1,
    "toxic": 1,
    "water": 1,
    "wind": 1,
  },
  "mental": {
    "crystal": 2,
    "digital": 2,
    "earth": 1,
    "electric": 2,
    "fire": 1,
    "melee": 0.5,
    "mental": 1,
    "nature": 1,
    "neutral": 0.5,
    "toxic": 1,
    "water": 1,
    "wind": 1,
  },
  "nature": {
    "crystal": 1,
    "digital": 1,
    "earth": 0.5,
    "electric": 0.5,
    "fire": 2,
    "melee": 1,
    "mental": 1,
    "nature": 0.5,
    "neutral": 1,
    "toxic": 2,
    "water": 0.5,
    "wind": 1,
  },
  "neutral": {
    "crystal": 1,
    "digital": 1,
    "earth": 1,
    "electric": 1,
    "fire": 1,
    "melee": 1,
    "mental": 2,
    "nature": 1,
    "neutral": 1,
    "toxic": 1,
    "water": 1,
    "wind": 1,
  },
  "toxic": {
    "crystal": 1,
    "digital": 1,
    "earth": 1,
    "electric": 1,
    "fire": 1,
    "melee": 1,
    "mental": 1,
    "nature": 0.5,
    "neutral": 1,
    "toxic": 0.5,
    "water": 0.5,
    "wind": 2,
  },
  "water": {
    "crystal": 1,
    "digital": 1,
    "earth": 0.5,
    "electric": 2,
    "fire": 0.5,
    "melee": 1,
    "mental": 1,
    "nature": 2,
    "neutral": 1,
    "toxic": 2,
    "water": 0.5,
    "wind": 1,
  },
  "wind": {
    "crystal": 1,
    "digital": 1,
    "earth": 0.5,
    "electric": 2,
    "fire": 1,
    "melee": 1,
    "mental": 1,
    "nature": 1,
    "neutral": 1,
    "toxic": 1,
    "water": 1,
    "wind": 0.5,
  },
}


export const calculateResistances = (types) => {
  if (!types) {
    return {};
  }
  const resistances = {
    "crystal": 1,
    "digital": 1,
    "earth": 1,
    "electric": 1,
    "fire": 1,
    "melee": 1,
    "mental": 1,
    "nature": 1,
    "neutral": 1,
    "toxic": 1,
    "water": 1,
    "wind": 1,
  }

  types.forEach((type) => {
    for (const [t, r] of Object.entries(resistanceTable[type])) {
      if (r !== 1) {
        resistances[t] = resistances[t] * r
      }
    }
  });

  return resistances;
}

export const calculateCoverage = (type) => {
  if (!type) {
    return
  }

  const coverage = {
    "CRYSTAL": 1,
    "DIGITAL": 1,
    "EARTH": 1,
    "ELECTRIC": 1,
    "FIRE": 1,
    "MELEE": 1,
    "MENTAL": 1,
    "NATURE": 1,
    "NEUTRAL": 1,
    "TOXIC": 1,
    "WATER": 1,
    "WIND": 1,
  }

  Object.keys(resistanceTable).forEach((res) => {
    coverage[res] = resistanceTable[res][type]
  })

  return coverage
}
